// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"472":"56dcf32d","787":"83f110a5"}[chunkId] + ".chunk.js";
};